import { isEmpty } from 'lodash';
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import styles from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
};

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const getUrl = (url) => {
  if (validateEmail(url)) return `mailto:${url}`;
  return url;
};

function Title({ event, settings, className = '', containerClassName = '' }) {
  const disableLink = isEmpty(event.get('url')) || settings.get('removeUrlLink');
  if (!settings.get('showEventTitle')) return <span />;
  return (
    <div className={cn(styles.title, className, 'title', containerClassName)}>
      {!disableLink ? (
        <a href={getUrl(event.get('url'))} target="_blank" rel="noopener noreferrer">
          {event.get('title')}
        </a>
      ) : (
        <span className={cn(styles.title, className, 'title')}>{event.get('title')}</span>
      )}
    </div>
  );
}

Title.propTypes = propTypes;

export default Title;
